<template>
  <nav ref="navMenu" :class="isHamburgerVisible ? 'revealAnimation' : ''">
    <a class="closeHamburgerMenu pointer" @click="hideHamburgerMenu"><span></span><span></span><span></span></a>
    <div class="optionDashboard">
      <div class="nav_title">
        <h6 class="--white">
          <a class="pointer" @click="clickNavMenu(0)">{{ $t('menu.my_page') }}</a>
        </h6>
      </div>
      <ul class="nav_gnb" style="scroll-behavior: smooth;">
        <li v-bind:class="[navMenu === 0 ? this.classes.active : this.classes.none]"
            @click="clickNavMenu(0, 'Options')">
          <div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M20.847 12c0 .41-.03.83-.09 1.24.31.3.532.68.663 1.11.16.63.08 1.29-.252 1.86l-.915 1.57a2.49 2.49 0 0 1-2.142 1.23c-.22 0-.442-.03-.653-.09-.664.52-1.388.94-2.162 1.25A2.46 2.46 0 0 1 12.912 22h-1.82a2.477 2.477 0 0 1-2.383-1.83 8.81 8.81 0 0 1-2.162-1.25 2.477 2.477 0 0 1-2.796-1.14l-.915-1.57a2.414 2.414 0 0 1-.251-1.86c.12-.43.341-.81.653-1.11a8.573 8.573 0 0 1 0-2.48c-.312-.3-.543-.68-.653-1.11-.161-.63-.08-1.29.251-1.86l.915-1.57a2.49 2.49 0 0 1 2.142-1.23c.221 0 .443.03.654.09a8.81 8.81 0 0 1 2.162-1.25A2.46 2.46 0 0 1 11.092 2h1.82c1.137 0 2.102.78 2.374 1.83a8.81 8.81 0 0 1 2.162 1.25 2.477 2.477 0 0 1 2.796 1.14l.915 1.57c.331.57.422 1.23.25 1.86-.12.43-.341.81-.653 1.11.06.41.09.83.09 1.24zm-2.263 1.81a6.67 6.67 0 0 0 0-3.63c-.06-.2.02-.42.201-.52l.463-.26c.221-.13.301-.4.17-.62l-.914-1.57a.437.437 0 0 0-.393-.23.47.47 0 0 0-.23.06l-.463.27c-.07.04-.141.06-.222.06a.475.475 0 0 1-.332-.14 6.773 6.773 0 0 0-3.157-1.82c-.211-.06-.352-.23-.352-.44v-.52a.45.45 0 0 0-.453-.45h-1.82a.45.45 0 0 0-.452.45v.53c0 .21-.151.39-.352.44A6.86 6.86 0 0 0 7.12 7.24a.475.475 0 0 1-.332.14c-.08 0-.15-.02-.221-.06l-.463-.27a.498.498 0 0 0-.231-.06c-.15 0-.312.08-.392.23l-.915 1.57c-.121.22-.05.49.17.62l.463.26a.45.45 0 0 1 .201.52A6.67 6.67 0 0 0 5.15 12c0 .63.09 1.23.251 1.81.06.2-.02.42-.2.52l-.463.26a.448.448 0 0 0-.171.62l.915 1.57c.08.15.231.23.392.23.08 0 .16-.02.231-.06l.463-.27c.07-.04.14-.06.221-.06.12 0 .241.05.332.14.855.87 1.94 1.51 3.158 1.82.21.06.352.23.352.44v.52c0 .25.2.45.452.45h1.82a.45.45 0 0 0 .453-.45v-.52c0-.21.15-.39.352-.44a6.859 6.859 0 0 0 3.157-1.82c.09-.09.212-.14.332-.14.08 0 .151.02.221.06l.463.27c.08.04.151.06.231.06.151 0 .312-.08.393-.23l.915-1.57c.12-.22.05-.49-.171-.62l-.463-.26a.45.45 0 0 1-.2-.52zM8 12c0-2.207 1.793-4 4-4s4 1.793 4 4-1.793 4-4 4-4-1.793-4-4zm2.015 0c0 1.098.887 1.985 1.985 1.985A1.989 1.989 0 0 0 13.985 12 1.982 1.982 0 0 0 12 10.015 1.982 1.982 0 0 0 10.015 12z"
                    fill="#fff"
                    opacity=".5"
              />
            </svg>
          </div>
          <span>
            {{ $t('my.options.title') }}
           </span>
        </li>
        <li v-bind:class="[navMenu === 1 ? this.classes.active : this.classes.none]"
            @click="clickNavMenu(1, 'Profile')">
          <div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm9.09 3.53c-1.82 0-3.29 1.39-3.46 3.16A7.88 7.88 0 0 0 12.02 20c1.61 0 3.1-.48 4.36-1.3-.17-1.77-1.64-3.17-3.46-3.17h-1.83zm1.81-2.01c2.39 0 4.42 1.54 5.17 3.67 1.2-1.4 1.93-3.21 1.91-5.19 0-4.41-3.59-8-8-8s-8 3.59-8 8c0 1.97.73 3.78 1.92 5.18.76-2.13 2.79-3.66 5.17-3.66h1.83zM8.88 9.77c0-1.72 1.4-3.12 3.12-3.12 1.72 0 3.12 1.39 3.12 3.12 0 1.72-1.4 3.12-3.12 3.12-1.72 0-3.12-1.4-3.12-3.12zm2 0c0 .62.5 1.12 1.12 1.12.61 0 1.12-.51 1.12-1.12 0-.62-.5-1.12-1.12-1.12-.62 0-1.12.5-1.12 1.12z"
                    fill="#fff"
                    opacity=".5"
              />
            </svg>
          </div>
          <span>{{ $t('my.profile.title') }}</span>
        </li>
        <!--    TODO: 운영 반영시 제거-->
        <li v-if="!live"
            v-bind:class="[navMenu === 2 ? this.classes.active : this.classes.none]"
            @click="clickNavMenu(2, 'Payment')"
        >
          <div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M3.7 4h16.6c.94 0 1.7.76 1.7 1.7v12.6c0 .94-.76 1.7-1.7 1.7H3.7c-.94 0-1.7-.76-1.7-1.7V5.7C2 4.76 2.76 4 3.7 4zM20 7.94V6H4v1.94h16zM4 10.78V18h16v-7.22H4zm9.93 3.73h3.62c.56 0 1 .45 1 1s-.45 1-1 1h-3.62c-.55 0-1-.45-1-1s.45-1 1-1z"
                    fill="#fff"
                    opacity=".5"
              />
            </svg>
          </div>
          <span>{{ $t('my.payment.title') }}</span>
        </li>
        <li v-bind:class="[navMenu === 3 ? this.classes.active : this.classes.none]"
            @click="clickNavMenu(3, 'ChangePw')">
          <div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M3 4h18c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1zm1 14h16V6H4v12zm1.02-3.97c.19.29.51.45.84.45.19 0 .38-.05.55-.16l.72-.47v.72c0 .55.45 1 1 1s1-.45 1-1v-.72l.72.47c.17.11.36.16.55.16.33 0 .65-.16.84-.45a1 1 0 0 0-.29-1.38l-1-.65.99-.65a1 1 0 0 0 .29-1.38 1 1 0 0 0-1.38-.29l-.72.47v-.72c0-.55-.45-1-1-1s-1 .45-1 1v.72l-.72-.47a1 1 0 0 0-1.38.29 1 1 0 0 0 .29 1.38l.99.65-.99.65c-.47.3-.6.92-.3 1.38zm7.73 0c.19.29.51.45.84.45.19 0 .38-.05.55-.16l.72-.47v.72c0 .55.45 1 1 1s1-.45 1-1v-.72l.72.47c.17.11.36.16.55.16.33 0 .65-.16.84-.45a1 1 0 0 0-.29-1.38l-1-.65.99-.65a1 1 0 0 0 .29-1.38 1 1 0 0 0-1.38-.29l-.72.47v-.72c0-.55-.45-1-1-1s-1 .45-1 1v.72l-.72-.47a1 1 0 0 0-1.38.29 1 1 0 0 0 .29 1.38l.99.65-.99.65c-.47.3-.6.92-.3 1.38z"
                    fill="#fff"
                    opacity=".5"
              />
            </svg>
          </div>
          <span>{{ $t('account.change_password') }}</span>
        </li>
        <li v-bind:class="[navMenu === 5 ? this.classes.active : this.classes.none]"
            @click="clickNavMenu(5, 'Cookie')">
          <div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="#fff" fill-rule="evenodd" clip-rule="evenodd" opacity=".5" d="M12 22C6.49 22 2 17.51 2 12c0-5.42 4.41-9.9 9.82-10 .28 0 .56.11.76.33.19.21.29.5.25.78l-.005.055-.005.055c-.01.7.36 1.26.94 1.51.48.21.72.74.55 1.24-.08.24-.12.45-.12.65 0 1.13.92 2.05 2.05 2.05.35 0 .69-.1 1.02-.29a1.01 1.01 0 0 1 1.33.3c.4.58 1.15.85 1.86.57a.99.99 0 0 1 1.34.73c.14.66.21 1.34.21 2.02 0 5.51-4.49 10-10 10zM10.9 4.08C7.02 4.62 4 7.99 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8c0-.21-.01-.43-.03-.64-.92.02-1.8-.31-2.47-.9-.41.14-.83.21-1.26.21-2.23 0-4.05-1.82-4.05-4.05 0-.16.01-.32.03-.48a3.6 3.6 0 0 1-1.32-2.06zM9.1 8.82a1.13 1.13 0 1 0 0-2.26 1.13 1.13 0 0 0 0 2.26zm4.05 3.43a1.13 1.13 0 1 1-2.26 0 1.13 1.13 0 0 1 2.26 0zm4.01 2.01a1.13 1.13 0 1 0 0-2.26 1.13 1.13 0 0 0 0 2.26zM7.97 12a1.13 1.13 0 1 1-2.26 0 1.13 1.13 0 0 1 2.26 0zm.9 5.44a1.13 1.13 0 1 0 0-2.26 1.13 1.13 0 0 0 0 2.26zm6.21-.57a1.13 1.13 0 1 1-2.26 0 1.13 1.13 0 0 1 2.26 0z"/>
            </svg>
          </div>
          <span>
              {{ $t('cookies.basic.btn01') }}
          </span>
        </li>
        <li v-bind:class="[navMenu === 4 ? this.classes.active : this.classes.none]"
            @click="clickNavMenu(4, 'Account')">
          <div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M13 3.99h6c.55 0 1 .45 1 1s-.45 1-1 1V20c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V5.99c-.55 0-1-.45-1-1s.45-1 1-1h6V3c0-.55.45-1 1-1s1 .45 1 1v.99zm-6 2V19h10V5.99H7zm2.92 9.51c.55 0 1-.45 1-1v-4.01c0-.55-.45-1-1-1s-1 .45-1 1v4.01c0 .56.44 1 1 1zm4.17 0c.55 0 1-.45 1-1v-4.01c0-.55-.45-1-1-1s-1 .45-1 1v4.01c0 .56.45 1 1 1z"
                    fill="#fff"
                    opacity=".5"
              />
            </svg>
          </div>
          <span>{{ $t('account.account') }}</span>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script>
import {mapActions} from 'vuex'

export default {
  name: 'OptionDashboard',
  data() {
    return {
      window: window,
      navMenu: 0,
      classes: {
        active: 'active pointer',
        none: 'pointer'
      },
      isHamburgerVisible: false,
      // TODO: 운영 반영시 제거
      live: process.env.VUE_APP_MODE === 'LIVE',
    }
  },
  methods: {
    ...mapActions(['setHamburgerVisible']),
    clickNavMenu(idx, id) {
      const content = document.getElementById(`generalOption`);
      const section = document.getElementById(`section${id}`);
      content.scrollTo(0, section.offsetTop);

      this.navMenu = idx;
      this.hideHamburgerMenu();
    },
    hideHamburgerMenu() {
      this.setHamburgerVisible(false);
      this.$modal.hide('blank-modal');
    },
  },
  watch: {
    isHamburgerVisible(newData) {
      this.isHamburgerVisible = newData;
    }
  },
  created() {
    this.unsubscribe = this.$store.subscribe((_mutation, state) => {
      this.isHamburgerVisible = state.isHamburgerVisible;
    })
  },
  beforeDestroy() {
    this.unsubscribe();
  },
}
</script>
<style lang="scss">
@import "@/scss/navi";
</style>